<script>
import Information from '@/components/invitation/InvitationInformation.vue';
export default {
  components: { Information },
  props: {
    selectedDocuments: [Object, Array],
    isVisible: Boolean
  },
  data() {
    return {
      hasErrors: null,
      isLoading: false,
      documentsToCancel: [],
      documentsCanNotCancel: []
    };
  },
  computed: {
    documentId() {
      return Array.isArray(this.selectedDocuments)
        ? this.selectedDocuments[0].documentId
        : this.selectedDocuments.documentId;
    }
  },
  watch: {
    isVisible(newValue) {
      this.isLoading = true;
      this.hasErrors = null;
      this.documentsToCancel = [];
      this.documentsCanNotCancel = [];
      if (newValue) {
        const cancelList = Array.isArray(this.selectedDocuments)
          ? this.selectedDocuments
          : [this.selectedDocuments];

        const documentIds = cancelList.map((document) => document.documentId);

        this.$documentsService
          .requestDocumentCancellation(documentIds)
          .then((response) => {
            this.isLoading = false;
            this.documentsToCancel = response.documentsToCancel || [];
            this.documentsCanNotCancel = response.documentsCanNotCancel || [];
          })
          .catch((error) => {
            this.hasErrors = true;
            console.error('Error:', error);
          })
          .finally(() => {
            this.isLoading = false;
          });
      }
    }
  },
  methods: {
    closeDocumentDialog() {
      this.$emit('close');
    },
    onConfirmCancellation() {
      this.$documentsService.cancelDocuments(this.documentsToCancel)
        .then(() => {
          this.closeDocumentDialog();
          this.$emit('cancelled', this.documentsToCancel);
        })
        .catch((error) => {
          console.error('Error during cancellation:', error);
        });
    }
  }
};
</script>
<template>
  <v-dialog
    v-if="selectedDocuments !== null"
    v-model="isVisible"
    width="500"
    @click:outside="closeDocumentDialog">
    <v-card>
      <DialogBaseColoredTitle>
        <span>
          {{ selectedDocuments && selectedDocuments.length > 0 ?
          $t('component.documents.documentCancellationDialog.documents') :
          $t('component.documents.documentCancellationDialog.document') }}
          {{ $t('component.documents.documentCancellationDialog.header') }}
        </span>
      </DialogBaseColoredTitle>
      <DialogBaseCloseIcon
        color="white"
        @click="closeDocumentDialog" />
      <v-divider></v-divider>
      <DialogBaseText>
        <v-row
          v-if="isLoading"
          justify="center"
          align="center"
          class="text-center">
          <v-col cols="auto">
            <Information no-button no-icon>
              <v-progress-circular
                indeterminate
                color="primary">
              </v-progress-circular>
              <br />
              {{ $t('component.documents.documentCancellationDialog.loading') }}
            </Information>
          </v-col>
        </v-row>
        <v-row v-if="!isLoading && !hasErrors">
          <v-col>
            <span v-if="documentsCanNotCancel.length && documentsToCancel.length">
              {{ $t('component.documents.documentCancellationDialog.partial.cancellation.message', {
              cancelledCount: documentsToCancel.length,
              totalCount: selectedDocuments.length}) }}
            </span>
            <span v-else-if="documentsCanNotCancel.length && !documentsToCancel.length">
              {{ $t('component.documents.documentCancellationDialog.full.cancellation.error.message', {
              documentId: documentId
            }) }}
            </span>
            <span v-else-if="documentsToCancel.length && !documentsCanNotCancel.length">
              {{ $t('component.documents.documentCancellationDialog.successful.cancellation.message', {
              documentId: documentId}) }}
            </span>
          </v-col>
        </v-row>
        <v-row v-if="hasErrors">
          <v-col>
            {{ $t('component.documents.documentCancellationDialog.cancellation.error.message') }}
          </v-col>
        </v-row>
      </DialogBaseText>
      <v-divider></v-divider>
      <DialogBaseActions>
        <v-row>
          <v-col>
            <v-btn
              block
              color="primary"
              :disabled="!documentsToCancel.length"
              @click="onConfirmCancellation">
              <span>{{ $t('global.yes') }}</span>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              block
              color="secondary"
              @click="closeDocumentDialog">
              <span>{{ $t('global.no') }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
